import React, {useState} from 'react';
import {FormikHelpers} from 'formik';

import {Form, Button} from '@components';

import {Props} from './types';
import _Base from './../_Base';

import * as handlers from './handlers';
import * as hooks from './hooks';

import './index.scss';

const SignUp: React.FC<Props> = props => {
  const [user, setUser] = useState({attributes: {email: ''}});

  const initialValues = {
    firstName: '',
    firstKana: '',
    lastName: '',
    lastKana: '',
    phoneNumber: '',
    email: user.attributes.email,
    prefecture: null,
    birthyear: null,
    birthmonth: null,
    birthday: null,
  };
  hooks.useMount(setUser);

  return (
    <_Base
      isModal={props.isModal}
      handleCloseModal={props.handleCloseModal}
      isAutoClose={false}
      size="sm"
      title={props.title}
      signIn={true}
    >
      <div className="w__signup-modal">
        <div className="w__message">
          <div>AnpiCheckerをご利用頂くには、代表者の情報登録が必要です。</div>
          <div>代表者情報入力後、ダッシュボードに移動できます。</div>
        </div>
        <Form.SignUp
          initialValues={initialValues}
          handleSubmit={(values: any, formikActions: FormikHelpers<any>) => {
            handlers.submit(values, formikActions);
          }}
          submitText="登録する"
          modal
        />
        <Button.Normal
          text="キャンセル"
          onClick={() => props.handleCloseModal(false)}
          className="b__cancel"
        />
      </div>
    </_Base>
  );
};

export default SignUp;
